import { Select, SelectProps, Theme } from "@mui/material";
import { createStyles, withStyles, WithStyles } from "@mui/styles";
import classNames from "classnames";
import * as React from "react";

const styles = (theme: Theme) => createStyles({

    warning: {
        backgroundColor: theme.genie.palette.warning.dark,
        color: theme.palette.common.white,
        fontWeight: "bold",
        paddingLeft: 2,
        paddingRight: 2,
        "& svg": {
            color: theme.palette.common.white,
        }
    }

});

type Props = SelectProps & WithStyles<typeof styles>;

const MuiSelectFilter: React.FC<Props> = (props) => {
    const { classes, className, children, ...rest } = props;

    const cls = classNames({
        [classes.warning]: true,
        [className]: className !== undefined,
    });

    return <Select {...rest} className={cls}>{children}</Select>;
};

export default withStyles(styles)(MuiSelectFilter);